<nb-layout windowMode>
  <nb-layout-column>
    <nb-card>
      <nb-card-header>
        <a routerLink="/">
          <button nbButton ghost>
            <nb-icon status="primary" icon="arrow-back"></nb-icon>
          </button>
        </a>
      </nb-card-header>
      <nb-card-body class="login-card-body" style="padding: 0">
        <div class="wrapper">
          <div class="login-page">
            <h1>Entre no Marketplace</h1>
            <p>Olá! Me dê suas credenciais para entrar na nossa plataforma</p>
            <form (submit)="onFormSubmit($event)" [formGroup]="form">
              <div class="form-control-group">
                <label>Endereço de e-mail</label>
                <input nbInput fullWidth formControlName="email" type="email" />
              </div>

              <div class="form-control-group">
                <span class="label-with-link">
                  <label>Senha</label>
                  <a routerLink="/esqueci-senha"></a>
                </span>
                <input nbInput fullWidth type="password" formControlName="senha" />
              </div>

              <div class="checkboxes">
                <nb-checkbox status="basic">Lembrar-me</nb-checkbox>
              </div>

              <div class="footer">
                <button nbButton status="primary" type="submit" [disabled]="form.invalid">
                  Entrar
                </button>
                <p style="margin-left: 8px;">
                  Não é registrado ainda? Clique <a routerLink="/registrar">aqui</a>
                </p>
              </div>
            </form>
          </div>
          <div class="illustration"></div>
        </div>
      </nb-card-body>
    </nb-card>
  </nb-layout-column>
</nb-layout>
